import { useState } from 'react'
import { useIsomorphicLayoutEffect, useLocation } from 'react-use'
import { navigate } from 'gatsby'
import { getLocalizedSitePath } from '@utils/quiz'
import { useLocale } from '@hooks/useLocale'
import SectionDivider, { directions } from '@components/common/sectionDivider'
import Button from '@components/common/button'

const PinnedCTA = ({ show = false, landing, results }) => {
  const location = useLocation()
  const locale = useLocale()
  const [fromQuiz, setfFromQuiz] = useState(true)

  useIsomorphicLayoutEffect(() => {
    setfFromQuiz(location?.state?.fromQuiz)
  }, [location])

  const handleTakeQuizClick = () => {
    navigate(getLocalizedSitePath(locale))
  }

  if (fromQuiz || !show) return null

  return (
    <div className="sticky inset-x-0 bottom-0 z-50 w-full bg-ac-black pb-4 shadow-[0px_-4px_4px_0px_rgba(0,0,0,0.25)]">
      <SectionDivider direction={directions.DOWN} />
      <div className="flex flex-col items-center gap-4 p-4 text-center">
        <span className="font-portrait-cy text-[36px] uppercase leading-none md:text-[48px] md:leading-tight">
          {landing?.landingIntroMessage}
        </span>
        <Button onClick={handleTakeQuizClick}>
          {results?.resultsTakeQuizButtonTitle}
        </Button>
      </div>
    </div>
  )
}

export default PinnedCTA
